import { Box, Skeleton } from '@mui/material';
import { FC } from 'react';
import { LabeledSectionSkeleton } from '../../../../shared/labeled-section/labeled-section.skeleton';
import { PreferedDateList, PreferedDateListItem } from './preferred-date-section.styles';

export const PreferredDateSectionSkeleton: FC = (props) => {
  const PreferedDateItemSkeleton = ({ keyWidth, valueWidth }: { keyWidth: number; valueWidth: number }) => {
    return (
      <PreferedDateListItem>
        <Box>
          <Skeleton variant="text" height={15} width={keyWidth} />
        </Box>
        <Box>
          <Skeleton variant="text" height={15} width={valueWidth} />
        </Box>
      </PreferedDateListItem>
    );
  };

  return (
    <LabeledSectionSkeleton labelWidth={170}>
      <PreferedDateList>
        <PreferedDateItemSkeleton keyWidth={50} valueWidth={70} />
        <PreferedDateItemSkeleton keyWidth={60} valueWidth={90} />
        <PreferedDateItemSkeleton keyWidth={40} valueWidth={50} />
      </PreferedDateList>
    </LabeledSectionSkeleton>
  );
};
